var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.variants),function(variant){return _c('b-spinner',{key:variant,staticClass:"mr-1",attrs:{"variant":variant,"type":"grow"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }